import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { _className, ComponentSync, EditableDBItemV3, LL_H_C, TS_CollapsableContainer } from '@nu-art/thunderstorm-frontend/index';
import { ICONS } from '@app/styles';
import { MUSTNeverHappenException } from '@nu-art/ts-common';
import { canEditPathway } from '../../../utils.js';
import { ModuleFE_Expression } from '@app/hcs-frontend';
import { ModuleFE_Pathway } from '../../../../../_entity/pathway/index.js';
import { ModuleFE_PathwayEditor } from '../../../../../modules/index.js';
import { ModuleFE_PathwayTransition } from '../../../../../_entity/pathway-transition/index.js';
import { Component_ExpressionPrettyPrinter } from '@app/hcs-frontend/expression';
/**
 * Reusable component for pathway manager, will be used to render a collapsable container in the context
 * of a pathway transition rendering the resolution function pretty print
 */
export class Component_CollapsablePrettyPrint extends ComponentSync {
    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return true;
    }
    render() {
        const transition = ModuleFE_PathwayTransition.cache.unique(this.props.transitionId);
        if (!transition)
            throw new MUSTNeverHappenException(`pathway transition with id ${this.props.transitionId} not found`);
        const currentPathwayId = ModuleFE_PathwayEditor.getViewedPathwayId();
        if (!currentPathwayId)
            throw new MUSTNeverHappenException('cannot render this function with no pathway context');
        const pathway = ModuleFE_Pathway.cache.unique(currentPathwayId);
        if (!pathway)
            throw new MUSTNeverHappenException(`pathway with id ${currentPathwayId} not found`);
        const resolutionFunction = ModuleFE_Expression.cache.unique(transition.resolutionFunctionId);
        let editableItem;
        if (resolutionFunction) {
            editableItem = new EditableDBItemV3(resolutionFunction, ModuleFE_Expression);
            editableItem.validate();
        }
        const canEdit = canEditPathway(pathway);
        return _jsx(LL_H_C, { className: 'section-value', children: _jsx(TS_CollapsableContainer, { className: _className(this.props.removeIndentation && 'remove-indentation'), headerRenderer: _jsxs(LL_H_C, { className: _className('collapsable-label', this.props.removeIndentation && 'main-title'), children: ["Resolution", editableItem?.hasErrors() && _jsx(ICONS.attention.component, {})] }), containerRenderer: () => {
                    if (!editableItem)
                        return _jsx("div", { onClick: () => {
                                if (!canEdit)
                                    return;
                                this.props.functions.selectResolutionFunctionEditor(this.props.transitionId);
                            }, className: _className('no-result-line', canEdit && 'clickable', this.props.removeIndentation && 'main-section'), children: canEdit ? 'Create new' : 'No resolution function' });
                    return _jsx(Component_ExpressionPrettyPrinter, { className: _className(this.props.removeIndentation && 'main-section'), editable: editableItem, showHeader: false });
                }, customCaret: _jsx(ICONS.advisorArrowDown.component, {}) }) });
    }
}
//# sourceMappingURL=Component_CollapsablePrettyPrint.js.map